/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  appVersion,
  googleClientId,
  loginUrl,
  loginLocal,
  checkENV,
  appENV,
  uatENV,
} from "../../components/Helpers/Config";
import GoogleLogin from "react-google-login";
import GoogleLogo from "../../common/images/google_logo.png";
import NIELogo from "../../common/images-new/nie-login-logo.jpg";
import { serverUrl } from "../../components/Helpers/Config";
import {
  USER_LOADING,
  LOGIN_SUCCESS,
  LOGIN_GOOGLE_FAILED,
  loadUser,
} from "../../redux/actions/auth";
import {
  NIE_TERMS_AND_CONDITIONS,
  PROFILE_POLICY,
} from "../../redux/actions/termsconditionsActions";
import { Modal } from "@mui/material";
import axios from "axios";
import { staticFiles } from "../../components/Helpers/Static";
import {
  tokenAuthorize,
  checkSecondaryLogin,
  parseJwt,
} from "../../components/Helpers/Common";
import {
  getProfilePic,
  convertDate,
  addAttribute,
} from "../../components/Helpers/Common";
import { apiAuthorizeKey } from "../../components/Helpers/Config";
import ModalTermsAndPolicy from "../../components/Modal/ModalTermsandPolicy";
import Loader from "../../components/Button/Loader";
import CloseIcon from "@mui/icons-material/Close";
import $ from "jquery";
import { GET_THEME_LOADER } from "../../redux/actions/auth";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import DOMPurify from "dompurify";
import { defaultTheme } from '../../pages/Theme';
import { showLoginError } from '../../components/Helpers/Common';
const LOADING_GIF = staticFiles.loading;

const LoginPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState("");
  const [isExternal, setIsExternal] = useState(false);
  const [isTemp, setIsTemp] = useState(false);

  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [showAnnouncementBanner, setShowAnnouncementBanner] = useState(true);

  const [bannerText, setBannerText] = useState("");

  const [autoLogoutBanner, setAutoLogoutBanner] = useState({
    show: false,
    message: ""
  });

  const [eemail, setEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [returnURL, setReturnURL] = useState(
    window.location.origin.split("//")[1]
  );
  const [isAllow, setisAllow] = useState("false");
  const [nieTermsAndCondition, setnieTermsAndCondition] = useState();
  const [externalTermsAndCondition, setexternalTermsAndCondition] = useState();
  const [nieCheckboxRequired, setnieCheckboxRequired] = useState(false);
  const [externalCheckboxRequired, setexternalCheckboxRequired] =
    useState(false);
  const [announcement, setannnouncement] = useState();
  const [isAnnoucementActive, setisAnnouncementActive] = useState();
  const [isExternalActive, setisExternalActive] = useState();
  const [isNieActive, setisNieActive] = useState();
  const [isShowError, setisShowError] = useState(false);
  const [termsPolicyNIEAcccount, setTermsPolicyNIEAcccount] = useState();
  const [termsPolicyExternalNIEAcccount, setTermsPolicyExternalNIEAcccount] =
    useState();
  const [termsAndConditionContent, setTermsAndConditionContent] = useState({
    modal: false,
    content: "",
    header: "",
  });

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handleUserIdChange = (event) => {
    setUserId(event.target.value);
  };
  const handleReturnURLChange = (event) => {
    setReturnURL(event.target.value);
  };

  const isLoading = useSelector((state) => state.auth.isLoading);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const isThemeLoader = useSelector((state) => state.auth.isThemeLoader);
  const switchTab = (tabId) => {
    if (!isLoading) {
      setErrorMessage("");
      if (tabId === 1) {
        setIsExternal(true);
        setIsTemp(false);
        setisAllow("false");
        setisShowError(false);
      } else if (tabId === 2) {
        setIsExternal(false);
        setIsTemp(true);
        setisAllow("false");
        setisShowError(false);
      } else {
        setIsExternal(false);
        setIsTemp(false);
        setisAllow("false");
        setisShowError(false);
      }
    }
  };

  const handleLogin = async (googleData) => {
    //localStorage.setItem("themeLoader", true);
    dispatch({ type: GET_THEME_LOADER, payload: true });
    dispatch({ type: USER_LOADING });

    return axios
      .post(serverUrl.LoginGoogle, { token: googleData.tokenId })
      .then((resp) => {
        if (resp.status === 200) {
          const tokenjwt = parseJwt(resp.data.token);
          const data = {
            token: resp.data?.token,
            email: tokenjwt?.email,
          };

          return axios
            .post(
              serverUrl.Login,
              // { 'token': resp.data.token }
              data
            )
            .then((resp) => {
              if (resp.status === 200) {
                //refreshGoogleTokenSetup(resp)
                dispatch({ type: LOGIN_SUCCESS, data: resp.data });
                dispatch(loadUser());
                if (resp.data?.themes?.color1 === null) {
                  dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
                }
              }
              // setErrorMessage("User not registered");
              showLoginError('MOE');
              dispatch({ type: GET_THEME_LOADER, payload: false });
            })
            .catch((err) => {
              tokenAuthorize(err?.response?.status);
              checkSecondaryLogin(err?.response?.status);
              dispatch({ type: LOGIN_FAILED, error: ["Invalid Access"] });
            });
        }
      })
      .catch((err) => {
        // tokenAuthorize(err?.response?.status);
        if (err.response && err.response.status === 401) {
          showLoginError('MOE');
          // setErrorMessage("User not registered");
        } else setErrorMessage("Invalid login");

        dispatch({ type: LOGIN_GOOGLE_FAILED, error: ["Login error"] });
      });
  };

  const handleFailedLogin = (response) => {
    setErrorMessage("Login failed");
  };

  useEffect(() => {
    if (isAuthenticated) {
      if (location && location.next) history.push(location.next);

      history.push("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    let reason = localStorage.getItem("autoLogout");
    if (reason) {
      let message = "You have been logged out. Please log in again to continue.";
      if (reason === 'idle') {
        message = "You have been logged out due to inactivity. Please log in again to continue.";
      }
      setAutoLogoutBanner({
        show: true,
        message: message
      });
      localStorage.removeItem("autoLogout");
    }
  }, []);

  function htmlToText(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }

  useEffect(() => {
    dispatch({ type: GET_THEME_LOADER, payload: true });
    axios
      .get(serverUrl.EditProfile, { headers: { "x-api-key": apiAuthorizeKey } })
      .then((res) => {
        if (res.status === 200) {
          let nie_account = res.data?.nie_account;
          let external_account = res.data?.external_account;
          let announcement = res.data.announcement;
          setexternalCheckboxRequired(external_account?.isCheckboxRequired);
          setnieCheckboxRequired(nie_account?.isCheckboxRequired);
          setannnouncement(announcement?.message);
          setisNieActive(nie_account?.canVisible);
          setisExternalActive(external_account?.canVisible);
          setisAnnouncementActive(announcement?.canVisible);

          dispatch({
            type: NIE_TERMS_AND_CONDITIONS,
            payload: res.data?.nie_account,
          });
          dispatch({
            type: PROFILE_POLICY,
            payload: res.data?.profile_consent,
          });

          let NIEMessage =
            nie_account?.DisplayLabel &&
            nie_account?.message.replace(
              `<span class="termsAndConditions" id="nieAccountTermsAndConditions"/>`,
              `<span class="termsAndConditions" id="nieAccountTermsAndConditions">${nie_account?.DisplayLabel}</span>`
            );
          setnieTermsAndCondition(NIEMessage);
          let NIEExternalMessage =
            external_account?.DisplayLabel &&
            external_account?.message.replace(
              `<span class="termsAndConditions" id="externalAccountTermsAndConditions"/>`,
              `<span class="termsAndConditions" id="externalAccountTermsAndConditions">${external_account?.DisplayLabel}</span>`
            );
          setexternalTermsAndCondition(NIEExternalMessage);
          setTermsPolicyNIEAcccount(nie_account.Policies || "");
          setTermsPolicyExternalNIEAcccount(external_account?.Policies || "");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch({ type: GET_THEME_LOADER, payload: false });
      });
  }, []);

  useEffect(() => {
    if (announcement) {
      const plainText = DOMPurify.sanitize(announcement, {
        FORBID_TAGS: ["img", "script"],
        ALLOWED_TAGS: ["b", "i", "em", "strong", "p"],
      });


      setBannerText(plainText);
    }
  }, [announcement]);

  const [maxLength, setMaxLength] = useState(322);

  // 👇 Your function goes here
  const updateLength = () => {
    const charsPerPixel = 0.18; // adjust this ratio for your UI
    const dynamicLength = Math.floor(window.innerWidth * charsPerPixel);
    setMaxLength(dynamicLength > 322 ? 322 : dynamicLength);
  };

  useEffect(() => {
    updateLength(); // run once at mount
    window.addEventListener("resize", updateLength);
    return () => window.removeEventListener("resize", updateLength);
  }, []);
  function truncateInlineHtml(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;

    let currentLength = 0;

    function truncateNode(node) {
      if (currentLength >= maxLength) {
        node.remove();
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const remaining = maxLength - currentLength;
        if (node.textContent.length > remaining) {
          node.textContent = node.textContent.slice(0, remaining);
          currentLength = maxLength;
        } else {
          currentLength += node.textContent.length;
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // loop forward since inline tags usually won't remove the parent
        for (let i = 0; i < node.childNodes.length; i++) {
          truncateNode(node.childNodes[i]);
        }
      }
    }

    truncateNode(div);

    return div.innerHTML;
  }
  function truncateHtmlFromEnd(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;

    let totalLength = 0;

    // Count total text length
    function countText(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        totalLength += node.textContent.length;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        node.childNodes.forEach(countText);
      }
    }
    countText(div);

    let removeLength = totalLength - maxLength;
    if (removeLength <= 0) return html; // nothing to truncate

    // Truncate from end
    function truncateNodeFromEnd(node) {
      if (removeLength <= 0) return;

      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length >= removeLength) {
          node.textContent = node.textContent.slice(
            0,
            node.textContent.length - removeLength
          );
          removeLength = 0;
        } else {
          removeLength -= node.textContent.length;
          node.remove();
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        // Traverse children **from end**
        for (let i = node.childNodes.length - 1; i >= 0; i--) {
          truncateNodeFromEnd(node.childNodes[i]);
        }
        // Remove empty tags
        if (node.textContent.trim() === "") {
          node.remove();
        }
      }
    }

    truncateNodeFromEnd(div);
    const last = getLastElementNode(div);
    let buttonHtml = `<button onclick="window.showAnnouncementModal()" class="inline text-blue-600 hover:text-blue-800 underline text-sm font-medium focus:outline-none rounded px-1 ">read more</button>`;
    if (last) last.innerHTML += "..." + buttonHtml;

    return div.innerHTML;
  }
  function getLastElementNode(node) {
    if (node.nodeType === Node.ELEMENT_NODE && node.childNodes.length > 0) {
      // Traverse children from end
      for (let i = node.childNodes.length - 1; i >= 0; i--) {
        const childLast = getLastElementNode(node.childNodes[i]);
        if (childLast) return childLast;
      }
      return node; // No element children, return self
    }
    return null;
  }
  const isTextTruncated = bannerText.length > maxLength;
  const displayText = !isTextTruncated
    ? bannerText
    : truncateHtmlFromEnd(bannerText, maxLength)
  // +
  //   "..." +
  //   `<button onclick="window.showAnnouncementModal()" class="inline text-blue-600 hover:text-blue-800 underline text-sm font-medium focus:outline-none rounded px-1 ">read more</button>`;

  // Changed the login URL pp1/sso for both local and SIT
  // const loginValidUrl = appENV === checkENV ? loginLocal : loginUrl;
  const loginValidUrl = loginUrl;

  useEffect(() => {
    // Add global function for show more button
    window.showAnnouncementModal = () => setShowAnnouncementModal(true);

    $(document).on("click", ".termsAndConditions", function () {
      let content =
        $(this).attr("id") === "nieAccountTermsAndConditions"
          ? termsPolicyNIEAcccount
          : termsPolicyExternalNIEAcccount;
      setTermsAndConditionContent({
        content: content,
        modal: true,
        header: $(this).text() != "" ? $(this).text() : "Terms and Conditions",
      });
    });

    return () => {
      $(document).off("click", ".termsAndConditions"); // Cleanup event listener
      delete window.showAnnouncementModal; // Cleanup global function
    };
  });

  useEffect(() => {
    const loginError = Cookies.get("loginError");
    if (loginError) {
      setInterval(() => {
        const elements = document.getElementsByClassName("swal2-popup");
        if (elements?.length > 0) {
          Array.from(elements).forEach((element) => {
            element.style.setProperty('--bg-swal-color', defaultTheme?.white);
            element.style.setProperty('--icon-swal-color', defaultTheme?.blue);
            element.style.setProperty('--title-swal-color', defaultTheme?.black);
            element.style.setProperty('--html-swal-color', defaultTheme?.gray);
            element.style.setProperty('--button-swal-color', defaultTheme?.buttonTopColor);
          });
        }
      }, 1)
      Swal.fire({
        title: "Info",
        text: loginError == 'user_not_found' ? 'We couldn’t find your account' : 'Your account is not linked to MOE iCON',
        icon: "warning"
      })
      Cookies.remove("loginError");
    }
  }, []);

  if (isThemeLoader) {
    return <Loader />;
  }

  return (
    <div className="grid place-items-center gap-2 items-center bg-login min-h-screen relative">
      <div className="w-full self-start sticky top-0 left-0 z-50 flex flex-col">
        {autoLogoutBanner.show && (
          <div
            className={`w-full bg-red-100 border-b border-red-300 text-red-800 p-4 shadow line-clamp-3`}
          >
            <div className="mx-auto flex items-center justify-between">
              <div className="text-sm font-serif pr-2 flex-1">
                <div>{autoLogoutBanner.message}</div>
              </div>

              <button
                onClick={() => setAutoLogoutBanner({ show: false, message: "" })}
                className="ml-4 text-red-600 hover:text-red-800 flex-shrink-0"
              >
                ✕
              </button>
            </div>
          </div>
        )}

        {showAnnouncementBanner && isAnnoucementActive && announcement !== "" && (
          <div
            className={`sticky top-0 left-0 self-start w-full bg-yellow-100 border-b border-yellow-300 text-gray-800 p-4 z-50 shadow line-clamp-3`}
          >
            <div className="mx-auto flex items-center justify-between">
              <div className="text-sm font-serif pr-2 flex-1">
                <div dangerouslySetInnerHTML={{ __html: displayText }} />
              </div>

              <button
                onClick={() => setShowAnnouncementBanner(false)}
                className="ml-4 text-gray-600 hover:text-gray-800 flex-shrink-0"
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>

      {/* {(isAnnoucementActive && announcement !== "") &&
				<div className='max-w-xl rounded-2xl bg-white p-4'>
					<h4 className="font-bold text-lg text-gray-800 mb-2">Announcement</h4>
					<div className="text-gray-700 text-sm text-justify font-serif max-h-36 overflow-y-auto"
						dangerouslySetInnerHTML={{ __html: announcement }}
					/>
				</div>
				 } */}

      <div
        className={`bg-white rounded-2xl flex flex-col items-center p-8 m-5 max-w-xl sm:min-w-xl`}
      >
        <img src={NIELogo} alt="NIE Logo" className="img-300" />

        <div className={"h-5/6 w-full mt-5 "}>
          <div className="">
            <h1 className="text-black font-bold text-xl sm:text-2xl text-center">
              Welcome to Digital Portfolio
            </h1>

            <div className="my-4">
              <div className="w-full">
                <div className="flex flex-col sm:flex-row rounded-lg gap-2 p-1">
                  <button
                    onClick={() => {
                      switchTab(0);
                    }}
                    className={`flex-1 text-center py-3 px-4 rounded-lg bg-gray-100 font-medium focus:outline-none ${!isExternal && !isTemp
                      ? "border-b-4 border-blue-custom text-gray-800 shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    NIE Account
                  </button>
                  <button
                    onClick={() => {
                      switchTab(1);
                    }}
                    className={`flex-1 text-center py-3 px-4 rounded-lg bg-gray-100 font-medium focus:outline-none ${isExternal
                      ? "border-b-4 border-blue-custom text-gray-800 shadow-sm"
                      : "text-gray-500 hover:text-gray-700"
                      }`}
                  >
                    External Account
                  </button>
                  {appENV != uatENV && (
                    <button
                      onClick={() => {
                        switchTab(2);
                      }}
                      className={`flex-1 text-center py-3 px-4 rounded-lg bg-gray-100 font-medium focus:outline-none ${isTemp
                        ? "border-b-4 border-blue-custom text-gray-800 shadow-sm"
                        : "text-gray-500 hover:text-gray-700"
                        } `}
                    >
                      Temp Dev login
                    </button>
                  )}
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="w-full flex flex-col items-center mt-4">
                <img src={LOADING_GIF} alt="" className="w-10 h-10" />
                <p>Loading...</p>
              </div>
            ) : (
              <>
                {errorMessage && errorMessage.length > 0 && (
                  <div className="w-full flex flex-col items-center mb-4 text-red-600">
                    {Array.isArray(errorMessage)
                      ? errorMessage.map((msg) => msg)
                      : errorMessage}
                  </div>
                )}
                {isExternal ? (
                  <>
                    <GoogleLogin
                      render={(renderProps) =>
                        isExternalActive == false ||
                          externalTermsAndCondition === "" ||
                          (isExternalActive === true &&
                            externalCheckboxRequired === false) ||
                          (isExternalActive === true &&
                            externalCheckboxRequired === true &&
                            isAllow === "true") ? (
                          <button
                            onClick={() => renderProps.onClick()}
                            className={
                              "flex justify-center items-center w-full shadow-md font-semibold rounded-lg px-3 py-2 border border-gray-300  hover:bg-gray-100"
                            }
                          >
                            <img
                              src={GoogleLogo}
                              alt="google logo"
                              className="w-5 h-5 mr-2.5"
                            />
                            Sign in with Google
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              setisShowError(true);
                            }}
                            className={
                              "flex justify-center items-center w-full shadow-md font-semibold rounded-lg py-2 px-3 border border-gray-300 hover:bg-gray-100"
                            }
                            id="1"
                          >
                            <img
                              src={GoogleLogo}
                              alt="google logo"
                              className="w-5 h-5 mr-2.5"
                            />
                            Sign in with Google
                          </button>
                        )
                      }
                      clientId={googleClientId}
                      buttonText="Log in with Google"
                      onSuccess={handleLogin}
                      onFailure={handleFailedLogin}
                      cookiePolicy={"single_host_origin"}
                    />
                    {isExternalActive && externalTermsAndCondition !== "" && (
                      <div>
                        {isExternalActive &&
                          externalTermsAndCondition !== "" &&
                          externalCheckboxRequired &&
                          isShowError && (
                            <div className="w-full flex flex-col items-start mt-3 text-red-600">
                              Please acknowledge below to continue
                            </div>
                          )}

                        <div
                          className={`overflow-y-auto pr-5 ${isShowError ? "mt-2" : "mt-6"
                            }`}
                        >
                          <p className="text-black text-sm text-justify">
                            {externalCheckboxRequired && htmlToText("&nbsp;")}
                            <div className="text-viewer leading-tight flex flex-row justify-start items-start">
                              {externalCheckboxRequired && (
                                <label className="flex items-center space-x-2 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={isAllow === "true"}
                                    onChange={(e) => {
                                      setisAllow(
                                        e.target.checked ? "true" : "false"
                                      );
                                      setisShowError(false);
                                    }}
                                    className="hidden"
                                  />
                                  <span
                                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${isAllow === "true"
                                      ? "bg-blue-custom border-blue-custom"
                                      : "border-gray-400"
                                      }`}
                                  >
                                    {isAllow === "true" && (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4 text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    )}
                                  </span>
                                </label>
                              )}
                              {externalCheckboxRequired &&
                                htmlToText("&nbsp;&nbsp;")}
                              <div
                                className="relative -top-0 font-serif"
                                dangerouslySetInnerHTML={{
                                  __html: externalTermsAndCondition,
                                }}
                              />
                            </div>
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                ) : isTemp ? (
                  <div className="filter-sec">
                    <form className="form_sec">
                      <div className="flex flex-col gap-3">
                        <input
                          type="text"
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
		 focus:outline-none focus:ring-2 focus:ring-blue-custom focus:border-blue-custom 
		 text-lg font-medium"
                          placeholder="Your Email"
                          onChange={handleEmailChange}
                          onKeyPress={(e) => {
                            if (e.key == "Enter") {
                              if (
                                eemail.trim() !== "" &&
                                userId.trim() !== ""
                              ) {
                                window.location.href =
                                  loginValidUrl +
                                  "/" +
                                  eemail +
                                  "/" +
                                  userId +
                                  "/" +
                                  returnURL;
                              }
                            }
                          }}
                          autoComplete="off"
                        />

                        <input
                          type="text"
                          placeholder="Your User Id"
                          onKeyPress={(e) => {
                            if (e.key == "Enter") {
                              if (
                                eemail.trim() !== "" &&
                                userId.trim() !== ""
                              ) {
                                window.location.href =
                                  loginValidUrl +
                                  "/" +
                                  eemail +
                                  "/" +
                                  userId +
                                  "/" +
                                  returnURL;
                              }
                            }
                          }}
                          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
		 focus:outline-none focus:ring-2 focus:ring-blue-custom focus:border-blue-custom 
		 text-lg font-medium"
                          onChange={handleUserIdChange}
                          autoComplete="off"
                        />

                        {/* <div className="col">
												<div className="input_field">
													<input type="text" placeholder="Return back url" className="form-control" onChange={handleReturnURLChange} value={returnURL}/>
												</div>
											</div> */}
                      </div>

                      <br></br>
                      <div className="form-group text-center mb-4">
                        <a
                          href={
                            loginValidUrl +
                            "/" +
                            eemail +
                            "/" +
                            userId +
                            "/" +
                            returnURL
                          }
                          className="block text-center w-full text-white font-semibold bg-blue rounded-lg px-6 py-3 uppercase"
                        >
                          Temp Login
                        </a>
                      </div>
                    </form>
                  </div>
                ) : (
                  <>
                    {isNieActive == false ||
                      nieTermsAndCondition === "" ||
                      (isNieActive === true && nieCheckboxRequired === false) ||
                      (isNieActive === true &&
                        nieCheckboxRequired === true &&
                        isAllow === "true") ? (
                      <a
                        href={loginUrl}
                        className={
                          "text-white font-semibold bg-blue rounded-lg px-6 py-3 block w-full text-center  cursor-pointer"
                        }
                      >
                        Login
                      </a>
                    ) : (
                      <a
                        className={
                          isNieActive
                            ? nieCheckboxRequired
                              ? isAllow === "true"
                                ? "text-white font-semibold bg-blue rounded-lg px-28 py-3 "
                                : "block w-full text-center text-white font-semibold bg-blue rounded-lg px-28 py-3  cursor-pointer"
                              : "block w-full text-center text-white font-semibold bg-blue rounded-lg px-28 py-3 "
                            : "block w-full text-center text-white font-semibold bg-blue rounded-lg px-28 py-3 "
                        }
                        onClick={() => setisShowError(true)}
                      >
                        Login
                      </a>
                    )}

                    {isNieActive && nieTermsAndCondition !== "" && (
                      <div>
                        {isNieActive &&
                          nieTermsAndCondition !== "" &&
                          nieCheckboxRequired &&
                          isShowError && (
                            <div className="w-full flex flex-col items-start mt-4 text-red-600">
                              Please acknowledge below to continue
                            </div>
                          )}
                        <div
                          className={`overflow-y-auto pr-5 ${isShowError ? "mt-7" : "mt-10"
                            }`}
                        >
                          <p className="text-black text-sm text-justify">
                            {/* {nieCheckboxRequired && htmlToText("&nbsp;")} */}
                            <div className="text-viewer leading-tight flex flex-row justify-start items-start">
                              {nieCheckboxRequired && (
                                <label className="flex items-center space-x-2 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={isAllow === "true"}
                                    onChange={(e) => {
                                      setisAllow(
                                        e.target.checked ? "true" : "false"
                                      );
                                      setisShowError(false);
                                    }}
                                    className="hidden"
                                  />
                                  <span
                                    className={`w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors duration-200 ${isAllow === "true"
                                      ? "bg-blue-custom border-blue-custom"
                                      : "border-gray-400"
                                      }`}
                                  >
                                    {isAllow === "true" && (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4 text-white"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    )}
                                  </span>
                                </label>
                              )}

                              {nieCheckboxRequired &&
                                htmlToText("&nbsp;&nbsp;")}
                              <div
                                className="relative -top-0 font-serif"
                                dangerouslySetInnerHTML={{
                                  __html: nieTermsAndCondition,
                                }}
                              />
                            </div>
                            {/* <div>
																		{nieTermsAndCondition}
																	</div> */}
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className="grid gap-2 grid-cols-1 place-content-end w-full mt-auto">
          <div className="border-t my-4 w-full place-self-center" />
          <p className="text-black md:text-sm text-xs text-center">
            &copy; {new Date().getFullYear()} National Institute of Education
            Singapore. All rights reserved.<br></br>
          </p>
        </div>
      </div>
      {termsAndConditionContent.modal && (
        <ModalTermsAndPolicy
          showPolicyModal={termsAndConditionContent?.modal}
          PolicyContent={termsAndConditionContent}
          setShowPolicyModal={() =>
            setTermsAndConditionContent({
              content: "",
              modal: false,
              header: "",
            })
          }
        />
      )}

      <Modal
        open={showAnnouncementModal}
        onClose={() => setShowAnnouncementModal(false)}
      >
        <div className="fixed inset-0 flex items-center justify-center outline-none">
          <div className="relative bg-white rounded-2xl flex flex-col p-6 max-w-4xl w-full mx-4 outline-none shadow-lg max-h-80vh">
            {/* Header with Title + Close Icon */}
            <div className="flex items-center justify-between w-full mb-4">
              <h4 className="font-bold text-2xl text-black">Announcement</h4>
              <CloseIcon
                onClick={() => setShowAnnouncementModal(false)}
                className="cursor-pointer text-gray-500 hover:text-gray-700"
              />
            </div>

            {/* Scrollable Body */}
            <div className="w-full overflow-y-auto flex-1">
              <div
                className="text-gray-700 text-sm text-justify font-serif pr-2"
                dangerouslySetInnerHTML={{ __html: announcement }}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LoginPage;
// /* eslint-disable */
// import React, { useState, useEffect } from 'react';
// import { Redirect, useHistory, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { appVersion, googleClientId, loginUrl, loginLocal, checkENV, appENV, uatENV } from '../../components/Helpers/Config';
// import GoogleLogin from 'react-google-login';
// import GoogleLogo from '../../common/images/google_logo.png';
// import NIELogo from '../../common/images-new/nie-login-logo.jpg';
// import { serverUrl } from '../../components/Helpers/Config';
// import { USER_LOADING, LOGIN_SUCCESS, LOGIN_GOOGLE_FAILED, loadUser } from '../../redux/actions/auth';
// import axios from 'axios';
// import { staticFiles } from '../../components/Helpers/Static';
// import { tokenAuthorize, checkSecondaryLogin, parseJwt } from '../../components/Helpers/Common';
// import { getProfilePic, convertDate, addAttribute } from '../../components/Helpers/Common';
// import { apiAuthorizeKey } from '../../components/Helpers/Config';
// import ModalTermsAndPolicy from '../../components/Modal/ModalTermsandPolicy';
// import Loader from '../../components/Button/Loader';
// import $ from "jquery";
// const LOADING_GIF = staticFiles.loading;

// const LoginPage = () => {
// 	const dispatch = useDispatch();
// 	const location = useLocation();
// 	const history = useHistory();
// 	const [errorMessage, setErrorMessage] = useState('');
// 	const [isExternal, setIsExternal] = useState(false);
// 	const [isTemp, setIsTemp] = useState(false);

// 	const [eemail, setEmail] = useState('');
// 	const [userId, setUserId] = useState('');
// 	const [returnURL, setReturnURL] = useState(window.location.origin.split('//')[1]);
// 	const [isAllow, setisAllow] = useState("false");
// 	const [nieTermsAndCondition, setnieTermsAndCondition] = useState();
// 	const [externalTermsAndCondition, setexternalTermsAndCondition] = useState();
// 	const [nieCheckboxRequired, setnieCheckboxRequired] = useState(false);
// 	const [externalCheckboxRequired, setexternalCheckboxRequired] = useState(false);
// 	const [announcement, setannnouncement] = useState();
// 	const [isAnnoucementActive, setisAnnouncementActive] = useState();
// 	const [isExternalActive, setisExternalActive] = useState()
// 	const [isNieActive, setisNieActive] = useState()
// 	const [isShowError, setisShowError] = useState(false);
// 	const [termsPolicyNIEAcccount, setTermsPolicyNIEAcccount] = useState();
// 	const [termsPolicyExternalNIEAcccount, setTermsPolicyExternalNIEAcccount] = useState();
// 	const [termsAndConditionContent, setTermsAndConditionContent] = useState({
// 		modal: false,
// 		content: '',
// 		header: ''
// 	});

// 	const handleEmailChange = event => {
// 		setEmail(event.target.value);
// 	};
// 	const handleUserIdChange = event => {
// 		setUserId(event.target.value);
// 	};
// 	const handleReturnURLChange = event => {
// 		setReturnURL(event.target.value);
// 	};

// 	const isLoading = useSelector(state => state.auth.isLoading)
// 	const isAuthenticated = useSelector(state => state.auth.isAuthenticated)

// 	const switchTab = (tabId) => {
// 		if (!isLoading) {
// 			setErrorMessage('')
// 			if (tabId === 1) {
// 				setIsExternal(true);
// 				setIsTemp(false);
// 				setisAllow("false");
// 				setisShowError(false);

// 			}
// 			else if (tabId === 2) {
// 				setIsExternal(false);
// 				setIsTemp(true);
// 				setisAllow("false");
// 				setisShowError(false);

// 			}
// 			else {
// 				setIsExternal(false);
// 				setIsTemp(false);
// 				setisAllow("false");
// 				setisShowError(false);

// 			}
// 		}
// 	}

// 	const handleLogin = async (googleData) => {
// 		localStorage.setItem('themeLoader', true);
// 		dispatch({ type: USER_LOADING })

// 		return axios.post(
// 			serverUrl.LoginGoogle,
// 			{ token: googleData.tokenId }
// 		).then(resp => {
// 			if (resp.status === 200) {

// 				const tokenjwt = parseJwt(resp.data.token)
// 				const data = {
// 					token: resp.data?.token,
// 					email: tokenjwt?.email
// 				}

// 				return axios.post(
// 					serverUrl.Login,
// 					// { 'token': resp.data.token }
// 					data
// 				).then(resp => {
// 					if (resp.status === 200) {
// 						//refreshGoogleTokenSetup(resp)
// 						dispatch({ type: LOGIN_SUCCESS, data: resp.data });
// 						dispatch(loadUser());
// 						if (resp.data?.themes?.color1 === null) {
// 							dispatch({ type: GET_USER_DEFAULT_THEME, payload: "" });
// 						}
// 					}
// 					setErrorMessage('User not registered')
// 				}).catch(err => {
// 					tokenAuthorize(err?.response?.status);
// 					checkSecondaryLogin(err?.response?.status);
// 					dispatch({ type: LOGIN_FAILED, error: ['Invalid Access'] });
// 				});
// 			}
// 		}).catch(err => {
// 			tokenAuthorize(err?.response?.status);
// 			if (err.response && (err.response.status === 401)) {
// 				setErrorMessage('User not registered')
// 			}
// 			else setErrorMessage('Invalid login')

// 			dispatch({ type: LOGIN_GOOGLE_FAILED, error: ['Login error'] });
// 		});
// 	}

// 	const handleFailedLogin = (response) => {
// 		setErrorMessage('Login failed')
// 	}

// 	useEffect(() => {
// 		if (isAuthenticated) {
// 			if (location && location.next) history.push(location.next)

// 			history.push('/')
// 		}
// 	},
// 		[isAuthenticated])

// 	function htmlToText(html) {
// 		const parser = new DOMParser();
// 		const doc = parser.parseFromString(html, 'text/html');
// 		return doc.body.textContent || "";
// 	}

// 	useEffect(() => {
// 		axios.get(serverUrl.EditProfile, { headers: { 'x-api-key': apiAuthorizeKey } }).then(res => {
// 			if (res.status === 200) {
// 				let nie_account = res.data?.nie_account;
// 				let external_account = res.data?.external_account;
// 				let announcement = res.data.announcement;
// 				setexternalCheckboxRequired(external_account?.isCheckboxRequired);
// 				setnieCheckboxRequired(nie_account?.isCheckboxRequired);
// 				setannnouncement(announcement?.message);
// 				setisNieActive(nie_account?.canVisible);
// 				setisExternalActive(external_account?.canVisible);
// 				setisAnnouncementActive(announcement?.canVisible);
// 				let NIEMessage = nie_account?.message.replace(`<span class="termsAndConditions" id="nieAccountTermsAndConditions"/>`,
// 					`<span class="termsAndConditions" id="nieAccountTermsAndConditions">${nie_account?.DisplayLabel}</span>`
// 				);
// 				setnieTermsAndCondition(NIEMessage);
// 				let NIEExternalMessage = external_account?.message.replace(`<span class="termsAndConditions" id="externalAccountTermsAndConditions"/>`,
// 					`<span class="termsAndConditions" id="externalAccountTermsAndConditions">${external_account?.DisplayLabel}</span>`
// 				);
// 				setexternalTermsAndCondition(NIEExternalMessage);
// 				setTermsPolicyNIEAcccount(nie_account.Policies || '');
// 				setTermsPolicyExternalNIEAcccount(external_account?.Policies || '');
// 			}
// 		}).catch(err => {
// 			console.log(err);
// 		})
// 	}, [])

// 	const loading = localStorage.getItem("themeLoader") == 'true' ? true : false;
// 	// Changed the login URL pp1/sso for both local and SIT
// 	// const loginValidUrl = appENV === checkENV ? loginLocal : loginUrl;
// 	const loginValidUrl = loginUrl;

// 	useEffect(() => {
// 		$(document).on("click", ".termsAndConditions", function () {
// 			let content = $(this).attr("id") === "nieAccountTermsAndConditions" ? termsPolicyNIEAcccount : termsPolicyExternalNIEAcccount;
// 			setTermsAndConditionContent({
// 				content: content,
// 				modal: true,
// 				header: $(this).text() != "" ? $(this).text() : "Terms and Conditions"
// 			});
// 		});

// 		return () => {
// 			$(document).off("click", ".termsAndConditions"); // Cleanup event listener
// 		};
// 	});

// 	if (loading) {
// 		return (
// 			<Loader />
// 		)
// 	}

// 	return (
// 		<div className='flex flex-col h-full md:flex-row lg:grid grid-cols-2 h-screen'>
// 			<div className='h-1/3 md:h-full md:w-full grid slider content-center'>
// 				<div className='py-5 my-3 bg-white h-full flex justify-center items-center'>
// 					<img src={NIELogo} alt='nie logo' className='place-self-center w-6/12' />
// 				</div>
// 			</div>
// 			<div className='content-between flex flex-col md:w-full'>
// 				{(isAnnoucementActive && announcement !== "") &&
// 					<div className='h-24'>
// 						<div className='mt-10 text-black ml-auto mr-auto w-11/12 font-bold text-2xl '><h4>Announcement</h4></div>
// 						<div className='border border-gray-300 ml-auto mr-auto w-11/12 text-viewer overflow-y-auto min-h-24 h-24 max-h-24'>
// 							<p className='text-gray text-sm text-justify mt-2 pl-4 pr-6 font-serif' dangerouslySetInnerHTML={{ __html: announcement }} />
// 						</div>
// 					</div>
// 				}

// 				<div className={(isAnnoucementActive && announcement !== "") ? 'h-5/6 grid mb-5 mt-24 ' : 'h-5/6 grid mb-5 mt-5 '}>
// 					<div className='justify-self-center self-start md:place-self-center lg:place-self-center'>
// 						<h1 className='text-black font-bold text-2xl text-left'>Welcome to Digital Portfolio</h1>
// 						{/* {isAnnoucementActive && <p className='text-black text-sm mt-4 w-96 h-32 text-justify overflow-y-auto'>{announcement}Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.</p>} */}
// 						<div className='mt-8 mb-10 border-b'>
// 							<div className='flex text-black font-normal mb-3'>
// 								<p className='cursor-pointer mr-12' onClick={() => { switchTab(0); }}>NIE Account</p>
// 								<p className='cursor-pointer mr-12' onClick={() => { switchTab(1); }}>External Account</p>
// 								{appENV != uatENV && <p className='cursor-pointer' onClick={() => switchTab(2)}>Temp Dev login</p>}
// 							</div>
// 							{
// 								isExternal ?
// 									<div className='flex'>
// 										<div className='w-24 mr-11' />
// 										<div className='border-b-2 bg-blue w-32 transition ease-linear duration-300' />
// 										{appENV != uatENV && <div className='w-24 mr-11' />}
// 									</div>
// 									: isTemp ?
// 										<div className='flex'>
// 											<div className='w-24 mr-12' />
// 											<div className='w-24 mr-12' />
// 											<div className='border-b-2 bg-blue w-32 transition ease-linear duration-300' />
// 										</div>
// 										:
// 										<div className='flex'>
// 											<div className='border-b-2 bg-blue w-24 transition ease-linear duration-300' />
// 											<div className='w-24 mr-11' />
// 											{appENV != uatENV && <div className='w-24 mr-11' />}
// 										</div>
// 							}
// 							{/* <div className={isExternal ? 'w-24 mr-11' : 'border-b-2 bg-blue w-24 mr-11 transition ease-in-out duration-300'}/>
// 							<div className={isExternal ? 'border-b-2 bg-blue w-32 transition ease-linear duration-300' : 'w-32'}/> */}

// 						</div>
// 						{
// 							isLoading ?
// 								<div className='w-full flex flex-col items-center mt-4'>
// 									<img src={LOADING_GIF} alt='' className='w-10 h-10' />
// 									<p>Loading...</p>
// 								</div>
// 								:
// 								<>
// 									{
// 										(errorMessage && (errorMessage.length > 0)) &&
// 										<div className='w-full flex flex-col items-center mb-4 text-red-600'>
// 											{
// 												(Array.isArray(errorMessage)) ? errorMessage.map(msg => msg) : errorMessage
// 											}
// 										</div>
// 									}
// 									{
// 										isExternal ?
// 											<>
// 												<GoogleLogin
// 													render={
// 														renderProps => (
// 															(((isExternalActive == false || externalTermsAndCondition === "") || (isExternalActive === true && externalCheckboxRequired === false) || (isExternalActive === true && externalCheckboxRequired === true && isAllow === "true"))
// 																?
// 																<button
// 																	onClick={() => renderProps.onClick()}
// 																	className={'shadow-md font-semibold rounded-lg px-12 py-2 flex hover:bg-gray-100'}
// 																>
// 																	<img src={GoogleLogo} alt='google logo' className='w-5 h-5 mr-3' />
// 																	Sign in with Google
// 																</button>
// 																:
// 																<button
// 																	onClick={() => { setisShowError(true) }}
// 																	className={'shadow-md font-semibold rounded-lg px-12 py-2 flex hover:bg-gray-100'}
// 																	id="1"
// 																>
// 																	<img src={GoogleLogo} alt='google logo' className='w-5 h-5 mr-3' />
// 																	Sign in with Google
// 																</button>
// 															)
// 														)
// 													}
// 													clientId={googleClientId}
// 													buttonText="Log in with Google"
// 													onSuccess={handleLogin}
// 													onFailure={handleFailedLogin}
// 													cookiePolicy={'single_host_origin'}
// 												/>
// 												{(isExternalActive && externalTermsAndCondition !== "") &&
// 													<div>
// 														{(isExternalActive && externalTermsAndCondition !== "") && externalCheckboxRequired &&
// 															isShowError && <div className='w-full flex flex-col items-start mt-3 text-red-600'>
// 																Please acknowledge below to continue
// 															</div>}

// 														<div className={`w-96 max-h-44 overflow-y-auto pr-5 ${isShowError ? "mt-2" : "mt-10"}`}>
// 															<p className='text-black text-sm text-justify'>
// 																{externalCheckboxRequired && htmlToText("&nbsp;")}
// 																<div className='text-viewer leading-tight flex flex-row justify-start items-start'>
// 																	{externalCheckboxRequired && <input type='checkbox' value={isAllow === "false" ? true : false} checked={isAllow === "true" ? true : false} onClick={(e) => { setisAllow(e.target.value); setisShowError(false); }} />}
// 																	{externalCheckboxRequired && htmlToText("&nbsp;&nbsp;")}
// 																	<div className='relative -top-0 font-serif' dangerouslySetInnerHTML={{ __html: externalTermsAndCondition }} />
// 																</div>
// 															</p>
// 														</div>
// 													</div>}
// 											</>
// 											:
// 											isTemp ?
// 												<div lassName="filter-sec">
// 													<form className="form_sec">
// 														<div className="form-group">
// 															<div className="row">
// 																<div className="col">
// 																	<div className="input_field">
// 																		<input type="text" className="px-2 py-1 border-2 border-gray-300 rounded font-semibold text-2xl" placeholder="Your Email" onChange={handleEmailChange} autoComplete="off" />
// 																	</div>
// 																</div><br />
// 																<div className="col">
// 																	<div className="input_field">
// 																		<input type="text" placeholder="Your User Id" className="px-2 py-1 border-2 border-gray-300 rounded font-semibold text-2xl" onChange={handleUserIdChange} autoComplete="off" />
// 																	</div>
// 																</div>
// 																{/* <div className="col">
// 												<div className="input_field">
// 													<input type="text" placeholder="Return back url" className="form-control" onChange={handleReturnURLChange} value={returnURL}/>
// 												</div>
// 											</div> */}
// 															</div>
// 														</div>
// 														<br></br>
// 														<div className="form-group text-center">
// 															<a
// 																href={loginValidUrl + "/" + eemail + "/" + userId + "/" + returnURL}
// 																className='text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase'
// 															>
// 																Temp Login
// 															</a>
// 														</div>
// 													</form>
// 												</div>
// 												: <>
// 													{((isNieActive == false || nieTermsAndCondition === "") || (isNieActive === true && nieCheckboxRequired === false) || (isNieActive === true && nieCheckboxRequired === true && isAllow === "true"))
// 														? < a
// 															href={loginUrl}
// 															className={'text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase cursor-pointer'}
// 														>
// 															Login
// 														</a>
// 														:

// 														<a
// 															className={isNieActive ? nieCheckboxRequired ? isAllow === "true" ? 'text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase' : 'text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase cursor-pointer' : 'text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase' : 'text-white font-semibold bg-blue rounded-lg px-28 py-3 uppercase'}
// 															onClick={() => setisShowError(true)}
// 														>
// 															Login
// 														</a>

// 													}

// 													{(isNieActive && nieTermsAndCondition !== "") &&
// 														<div>
// 															{(isNieActive && nieTermsAndCondition !== "") && nieCheckboxRequired &&
// 																isShowError && <div className='w-full flex flex-col items-start mt-4 text-red-600'>
// 																	Please acknowledge below to continue
// 																</div>}
// 															<div className={`w-96 max-h-44 overflow-y-auto pr-5 ${isShowError ? "mt-7" : "mt-10"}`}>
// 																<p className='text-black text-sm text-justify'>
// 																	{/* {nieCheckboxRequired && htmlToText("&nbsp;")} */}
// 																	<div className='text-viewer leading-tight flex flex-row justify-start items-start'>
// 																		{nieCheckboxRequired && <input type='checkbox' value={isAllow === "false" ? true : false} checked={isAllow === "true" ? true : false} onClick={(e) => { setisAllow(e.target.value); setisShowError(false); }} />}
// 																		{nieCheckboxRequired && htmlToText("&nbsp;&nbsp;")}
// 																		<div className='relative -top-0 font-serif' dangerouslySetInnerHTML={{ __html: nieTermsAndCondition }} />
// 																	</div>
// 																	{/* <div>
// 																		{nieTermsAndCondition}
// 																	</div> */}
// 																</p>

// 															</div>
// 														</div>
// 													}
// 												</>
// 									}
// 								</>
// 						}
// 					</div>
// 				</div>
// 				<div className='grid gap-2 grid-cols-1 place-content-end'>
// 					<div className='border-t md:w-4/5 mb-4 w-full place-self-center' />
// 					<p className='text-black md:text-sm text-xs text-center'>{appVersion}</p>
// 					<p className='text-black md:text-sm mb-2 text-xs text-center'>
// 						&copy; {new Date().getFullYear()} National Institute of Education Singapore. All rights reserved.<br></br>
// 						<span className="text-center text-gray-600 footerVersionText">{process.env.REACT_APP_DP4_VERSION}</span>
// 					</p>
// 				</div>

// 			</div>
// 			{termsAndConditionContent.modal &&
// 				<ModalTermsAndPolicy
// 					showPolicyModal={termsAndConditionContent?.modal}
// 					PolicyContent={termsAndConditionContent}
// 					setShowPolicyModal={() => setTermsAndConditionContent({
// 						content: '',
// 						modal: false,
// 						header: ''
// 					})}
// 				/>}
// 		</div >
// 	)
// }

// export default LoginPage;
